import { client, clientWithoutErrorHandling } from '../http';

import consts from './constants';
import credentialsEncryptor from '../utils/credentialsEncryptor';
import serial from '../utils/serial';

async function fetchCredentials() {
  const response = await client.get('/api/credentials');
  return response.data;
}

async function updateCredentials({ credentialsId, credentials, name, status }) {
  const encryptedCredentials = safeEncrypt(credentials, { name, credentialsId });
  return await client.put(`/api/credentials/${credentialsId}`, { encryptedCredentials, name, user: consts.CUSTOMER_USER, status });
}

async function saveCredentials({ sourceName, credentials, name, sourceType }) {
  const encryptedCredentials = safeEncrypt(credentials, { name, sourceName });
  const response = await client.post('/api/save-credentials', { encryptedCredentials, name, user: consts.CUSTOMER_USER, sourceName, sourceType });
  return response.data;
}

async function savePendingCredentials({ sourceName, credentials, name }) {
  const encryptedCredentials = safeEncrypt(credentials, { name, sourceName });
  const response = await client.post('/api/save-pending-credentials', { encryptedCredentials, name, user: consts.CUSTOMER_USER, sourceName });
  return response.data;
}

async function deleteCredentials({ credentialsId }) {
  return await client.delete(`/api/credentials/${credentialsId}`, { user: consts.CUSTOMER_USER });
}

async function deletePendingCredentials() {
  const response = await client.delete('/api/pending-credentials');
  return response.data;
}

async function createCredentials({ sourceName }) {
  const response = await client.post('/api/credentials', { sourceName, user: consts.CUSTOMER_USER });
  return response.data;
}

async function checkCredentials({ sourceName, credentials, safeId, credentialsId, renew }) {
  const encryptedCredentials = safeEncrypt(credentials, { sourceName });
  const response = await clientWithoutErrorHandling.post('/api/check-credentials', {
    source: sourceName,
    encryptedCredentials,
    safeId,
    credentialsId,
    renew,
  });
  return response.data;
}

async function createMultipleCredentials({ sourceNames }) {
  return await serial.serialFor(sourceNames, async sourceName => await createCredentials({ sourceName, user: consts.CUSTOMER_USER }));
}

async function fetchCredsToAccounts() {
  const response = await client.get('/api/creds-to-accounts');
  return response.data;
}

function safeEncrypt(object, logData) {
  const encrypted = credentialsEncryptor.encrypt(object);
  if (encrypted === 'false') {
    throw new Error(`Failed encrypting object ${JSON.stringify(logData)}`);
  }
  return encrypted;
}

async function logCredsCheck(credentialsId, isValid, reason) {
  await client.post('/api/credentials-events/immediate-creds-check', { credentialsId, isValid, reason });
}

export default {
  fetchCredentials,
  updateCredentials,
  deleteCredentials,
  createCredentials,
  saveCredentials,
  checkCredentials,
  createMultipleCredentials,
  fetchCredsToAccounts,
  savePendingCredentials,
  deletePendingCredentials,
  logCredsCheck,
};
